import { Component, Input } from "@angular/core";
import { StepStateEnum, WorkflowStepConfig } from "../models/workflow-step-config";
import { CommonModule } from "@angular/common";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";

@Component({
    selector: "eff-workflow-popover",
    templateUrl: "./eff-workflow-popover.component.html",
    styleUrls: ["./eff-workflow-popover.component.scss"],
    imports: [CommonModule, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)]
})
export class EffWorkflowPopoverComponent {
    @Input() step: WorkflowStepConfig;
    stepStateEnum = StepStateEnum;
}
